import React from "react";
import { Alert } from "antd";
import type { CSSProperties } from "react";
import type { AlertProps } from "antd";

import { W1 } from "@components/Constants";

import Markdown from "./Markdown";

type Props = {
  text: string;
  type?: AlertProps["type"];
  style?: CSSProperties;
};

const MarkdownAlert = ({
  type = "info",
  style: extraStyle = {},
  text,
}: Props): JSX.Element => {
  const style: CSSProperties = {
    paddingTop: 0,
    marginBottom: W1,
    paddingBottom: 0,
    ...extraStyle,
  };

  const message = <Markdown text={text} />;

  return (
    <Alert
      type={type}
      style={style}
      message={message}
    />
  );
};

export default MarkdownAlert;
